// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qe3GD6nxZPQDbku2hPdG:first-child {
  justify-content: flex-start;
}

.qe3GD6nxZPQDbku2hPdG:hover {
  color: #055ada;
  background: transparent;
}

.__jzG5Ss6RFEscNKufhG {
  font-size: 18px;
  font-weight: 760;
  letter-spacing: 0.43px;
  line-height: 129.41%;
  text-align: center;
  margin: 0 auto;
}

.QUEcvupL27lfmKkIU35S {
  display: flex;
  flex-direction: column;
  min-height: 95%;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background: rgb(var(--primary-bg));
}

/*--------------------actions buttons--------------------*/
  
.O8a8Xv901xsID4LEQH9x {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  gap: 5px;
  margin: 20px 0;
}

._opMVLKHFHFvQ6s1PsAn {
  grid-template-columns: repeat(2, 1fr) !important;
}

.xdmP5W8XbFu0KzdJ6j9A {
  border-radius: 60px;
  background: rgba(0, 122, 255, 0.10);
  padding: 4.6px 13px;
  color: #007AFF;
  font-weight: 540;
  line-height: 129%;
  letter-spacing: 0.43px;
  font-size: 17px;
  width: 100%;
  gap: 1px;
  height: auto;
  margin-left: auto;
}

.xdmP5W8XbFu0KzdJ6j9A:hover {
  background: rgba(0, 122, 255, 0.10);
}

/*--------------------/actions buttons--------------------*/

/*--------------------transactions--------------------*/

.aygDtd3s9WSGdFecg25C {
  margin-top: -5px;
  margin-bottom: 20px;
}

.knIfFT4tVdNoj9R6ISgg {
  font-size: 20px;
  font-weight: 560;
  margin-bottom: 5px;
}
  
/*--------------------/transactions--------------------*/

/*--------------------transactions--------------------*/

/* .transactions {
  height: 100%;
} */

.knIfFT4tVdNoj9R6ISgg {
  font-size: 25px;
}

/* .transactionsItems {
  height: 85%;
} */

.eTLhb2MHsqO6ZgaXMPUH {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 22px;
  font-weight: 540;
  margin: 50px 0;
}
  
/*--------------------/transactions--------------------*/

/*--------------------history ton--------------------*/
  
.ZMvrvzx9O7k49ZVjDJQj {
  max-height: 100%;
  overflow-y: auto;
}

.LtqPw8QcJeM0dKHqsc3Z {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  position: relative;
  padding: 16px 10px 17px 10px;
  cursor: pointer;
  border-radius: 24px;
  margin-bottom: 4px;
}

.LtqPw8QcJeM0dKHqsc3Z::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 0.7px;
  bottom: -2px;
  right: 0;
  background: rgba(116, 116, 128, 1);
  opacity: 0.15;
}

.LtqPw8QcJeM0dKHqsc3Z:active {
  background: rgba(var(--placeholder-tertiary), 0.2);
}

/* .transItem:hover {
  background: rgba(var(--placeholder-tertiary), 0.2);
} */

.AcIbmDxJsYwN6ql1xTPQ {
  display: flex;
  align-items: center;
  gap: 6px;
}

.Au4BVMkfY4k_CcoCff0w {
  min-width: 40px;
  min-height: 40px;
  max-width: 40px;
  max-height: 40px;
  border-radius: 50%;
  /* background: #007AFF; */
  font-size: 18px;
  font-weight: 760;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.w8Q4LjSg62_JTBfrZkBh {
  font-size: 16px;
  font-weight: 560;
  margin-bottom: 2px;
}

@media (max-width: 350px) {
  .w8Q4LjSg62_JTBfrZkBh {
    font-size: 15px;
  }
  .t7I0EMaa4ScqOVQ60CQ4 {
    font-size: 13.5px;
  }
  .XR0WiW9vaIhyyyAMG1Kh {
    font-size: 15px;
  }
}


.t7I0EMaa4ScqOVQ60CQ4 {
  font-size: 13.5px;
  color: #8E8E93;
}

.XR0WiW9vaIhyyyAMG1Kh {
  color: #34C759;
  text-align: right;
  font-size: 16.5px;
  font-weight: 540;
}

@media (max-width: 380px) {
  .w8Q4LjSg62_JTBfrZkBh {
    font-size: 15px;
  }
  .XR0WiW9vaIhyyyAMG1Kh {
    font-size: 15px;
  }
  .t7I0EMaa4ScqOVQ60CQ4 {
    font-size: 13px;
    color: #8E8E93;
  }
}

.eTLhb2MHsqO6ZgaXMPUH {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  text-align: center;
  font-size: 22px;
  font-weight: 540;
}

/*--------------------/history ton--------------------*/

@media (max-width: 350px) {
  .xdmP5W8XbFu0KzdJ6j9A {
    font-size: 16px;
    padding: 4.6px 10px;
  }
}

/*--------------------new design--------------------*/

.UOKTke90FGH4ukaFWY48 {
  min-height: auto !important;
}

._8FOUGVRr697wHlCArPL {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.mCH41iDVexr0pvyqIC80 {
  margin: 0 0 24px 0;
  position: relative;
  background: rgb(var(--secondary-bg));
  border-radius: 32px;
  overflow: hidden;
  min-height: 216px;
  padding: 24px 12px 30px 12px;
}

.Le1R8xuf08MFvH6L8KVG {
  position: absolute;
  top: 35px;
  left: 0;
  height: 94%;
  width: 100%;
  z-index: 0;
}

.iTeCBpe_1ZZetmKmm24y {
  display: flex;
  align-items: center;
  z-index: 1;
  position: relative;
  gap: 16px;
  margin-bottom: 20px;
}

.iTeCBpe_1ZZetmKmm24y > img {
  width: 64px;
  height: 64px;
  border-radius: 50%;
}

.gs0_v82A9dmz0yKkifgp {
  font-size: 22px;
  font-weight: 560;
  letter-spacing: 0.43px;
}

.myeif2Equ35sbM61bDGD {
  font-size: 16px;
  line-height: 125%;
  letter-spacing: -0.5px;
}

.Y8taCPxrXrtxQ75I9VfA {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 8px;
  border-radius: 28px;
  background: rgba(64, 69, 74, 0.40);
  position: relative;
  z-index: 1;
  backdrop-filter: blur(28.950000762939453px);
  -webkit-backdrop-filter: blur(28.9px); 
}

.T7w1rHIVIrQaCigO8zPa {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;
  z-index: 1;
  position: relative;
  background: none;
  font-size: 14px;
  font-weight: 400;
  font-family: 'Inter';
  transition: background 0.3s ease 0s;
  border-radius: 10px;
  cursor: pointer;
}

.T7w1rHIVIrQaCigO8zPa:active {
    background: rgba(var(--placeholder-tertiary), 0.2);
}

/* .infoActionButton:hover {
  background: rgba(var(--placeholder-tertiary), 0.2);
} */

/* .infoActionButton:hover {
  opacity: 0.80;
} */

@media (max-width: 370px) {
  .T7w1rHIVIrQaCigO8zPa {
    padding: 5px 10px;
    font-size: 13px;
  }
  .eztltzYMyforvSqLSj6S > .T7w1rHIVIrQaCigO8zPa {
    padding: 5px 8px !important;
  }
}

@media (max-width: 340px) {
  .T7w1rHIVIrQaCigO8zPa > svg {
    width: 35px;
    height: 35px;
  }
  .HG2oSYuMIjH1mjh6oc2D {
    display: none;
  }
  .eztltzYMyforvSqLSj6S > .T7w1rHIVIrQaCigO8zPa {
    font-size: 10.5px;
  }
}

.eztltzYMyforvSqLSj6S > .HG2oSYuMIjH1mjh6oc2D {
  display: none;
}

.eztltzYMyforvSqLSj6S > .T7w1rHIVIrQaCigO8zPa {
  padding: 5px 8px !important;
}

.HG2oSYuMIjH1mjh6oc2D {
  width: 1px;
  height: 53px;
  background: rgb(var(--placeholder-primary));
  opacity: 0.1;
}

@media (max-width: 350px) {
  .Y8taCPxrXrtxQ75I9VfA {
    padding: 10px 3px;
  }
}

/*--------------------stats--------------------*/
  
.xGfqP_qaaddGGrVlO0s_ {
  background: rgb(var(--secondary-bg), 0.40);
  border-radius: 32px;
  padding: 20px 16px;
  position: relative;
  margin-bottom: 24px;
}
/* 
.statsLeft {
  position: absolute;
  top: 21px;
  left: 16px;
} */

.qKOAOQJnsl0vaDMTD8JN {
  font-size: 22px;
  font-weight: 760;
  line-height: 120%;
}

.ZD5K2zXvbzhWccNDMOac {
  font-size: 14px;
}

.dUyhRu8pI2zqPWFXqH8c canvas {
  width: 100% !important;
}

/*--------------------/stats--------------------*/

/*--------------------transactions--------------------*/
  
.aygDtd3s9WSGdFecg25C {
  background: rgb(var(--secondary-bg), 0.40);
  border-radius: 32px;
  padding: 16px;
}

/* .checkModal {
  padding: 20px;
} */

.aygDtd3s9WSGdFecg25C {
  padding: 20px 16px;
}


/*--------------------/transactions--------------------*/

.IGB1lpbQue8GLR5SMoZ_ {
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 40%;
  bottom: 0;
  border-radius: 600px;
  background: rgba(0, 122, 255, 0.25);
  filter: blur(110px) !important;
  -webkit-backdrop-filter: blur(110px) !important; 
}

/*--------------------/new design--------------------*/`, "",{"version":3,"sources":["webpack://./src/pages/main/jetton-detail/jetton-detail.module.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,0DAA0D;;AAE1D;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,2DAA2D;;AAE3D,uDAAuD;;AAEvD;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,wDAAwD;;AAExD,uDAAuD;;AAEvD;;GAEG;;AAEH;EACE,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wDAAwD;;AAExD,sDAAsD;;AAEtD;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,QAAQ;EACR,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,kDAAkD;AACpD;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF;;;AAGA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,uDAAuD;;AAEvD;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA,qDAAqD;;AAErD;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;EACV,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,gDAAgD;;AAEhD;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;;;;GAKG;;AAEH;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,iDAAiD;;AAEjD,uDAAuD;;AAEvD;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;AACf;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;AACpB;;;AAGA,wDAAwD;;AAExD;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,mCAAmC;EACnC,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA,sDAAsD","sourcesContent":[".modalTopButton:first-child {\n  justify-content: flex-start;\n}\n\n.modalTopButton:hover {\n  color: #055ada;\n  background: transparent;\n}\n\n.modalTitle {\n  font-size: 18px;\n  font-weight: 760;\n  letter-spacing: 0.43px;\n  line-height: 129.41%;\n  text-align: center;\n  margin: 0 auto;\n}\n\n.modal2 {\n  display: flex;\n  flex-direction: column;\n  min-height: 95%;\n  max-height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background: rgb(var(--primary-bg));\n}\n\n/*--------------------actions buttons--------------------*/\n  \n.actionsButtons {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  align-items: center;\n  gap: 5px;\n  margin: 20px 0;\n}\n\n.actionsButton2 {\n  grid-template-columns: repeat(2, 1fr) !important;\n}\n\n.actionButton {\n  border-radius: 60px;\n  background: rgba(0, 122, 255, 0.10);\n  padding: 4.6px 13px;\n  color: #007AFF;\n  font-weight: 540;\n  line-height: 129%;\n  letter-spacing: 0.43px;\n  font-size: 17px;\n  width: 100%;\n  gap: 1px;\n  height: auto;\n  margin-left: auto;\n}\n\n.actionButton:hover {\n  background: rgba(0, 122, 255, 0.10);\n}\n\n/*--------------------/actions buttons--------------------*/\n\n/*--------------------transactions--------------------*/\n\n.transactions {\n  margin-top: -5px;\n  margin-bottom: 20px;\n}\n\n.transactionsTitle {\n  font-size: 20px;\n  font-weight: 560;\n  margin-bottom: 5px;\n}\n  \n/*--------------------/transactions--------------------*/\n\n/*--------------------transactions--------------------*/\n\n/* .transactions {\n  height: 100%;\n} */\n\n.transactionsTitle {\n  font-size: 25px;\n}\n\n/* .transactionsItems {\n  height: 85%;\n} */\n\n.historyEmpty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  font-size: 22px;\n  font-weight: 540;\n  margin: 50px 0;\n}\n  \n/*--------------------/transactions--------------------*/\n\n/*--------------------history ton--------------------*/\n  \n.transItems {\n  max-height: 100%;\n  overflow-y: auto;\n}\n\n.transItem {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  position: relative;\n  padding: 16px 10px 17px 10px;\n  cursor: pointer;\n  border-radius: 24px;\n  margin-bottom: 4px;\n}\n\n.transItem::after {\n  content: '';\n  position: absolute;\n  width: 100%;\n  height: 0.7px;\n  bottom: -2px;\n  right: 0;\n  background: rgba(116, 116, 128, 1);\n  opacity: 0.15;\n}\n\n.transItem:active {\n  background: rgba(var(--placeholder-tertiary), 0.2);\n}\n\n/* .transItem:hover {\n  background: rgba(var(--placeholder-tertiary), 0.2);\n} */\n\n.transItemLeft {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.transItemLogo {\n  min-width: 40px;\n  min-height: 40px;\n  max-width: 40px;\n  max-height: 40px;\n  border-radius: 50%;\n  /* background: #007AFF; */\n  font-size: 18px;\n  font-weight: 760;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.transItemLeftStatus {\n  font-size: 16px;\n  font-weight: 560;\n  margin-bottom: 2px;\n}\n\n@media (max-width: 350px) {\n  .transItemLeftStatus {\n    font-size: 15px;\n  }\n  .transItemLeftFrom {\n    font-size: 13.5px;\n  }\n  .transItemRight {\n    font-size: 15px;\n  }\n}\n\n\n.transItemLeftFrom {\n  font-size: 13.5px;\n  color: #8E8E93;\n}\n\n.transItemRight {\n  color: #34C759;\n  text-align: right;\n  font-size: 16.5px;\n  font-weight: 540;\n}\n\n@media (max-width: 380px) {\n  .transItemLeftStatus {\n    font-size: 15px;\n  }\n  .transItemRight {\n    font-size: 15px;\n  }\n  .transItemLeftFrom {\n    font-size: 13px;\n    color: #8E8E93;\n  }\n}\n\n.historyEmpty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 30px;\n  text-align: center;\n  font-size: 22px;\n  font-weight: 540;\n}\n\n/*--------------------/history ton--------------------*/\n\n@media (max-width: 350px) {\n  .actionButton {\n    font-size: 16px;\n    padding: 4.6px 10px;\n  }\n}\n\n/*--------------------new design--------------------*/\n\n.transWeb {\n  min-height: auto !important;\n}\n\n.modalInner {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.modalInfo {\n  margin: 0 0 24px 0;\n  position: relative;\n  background: rgb(var(--secondary-bg));\n  border-radius: 32px;\n  overflow: hidden;\n  min-height: 216px;\n  padding: 24px 12px 30px 12px;\n}\n\n.modalBg {\n  position: absolute;\n  top: 35px;\n  left: 0;\n  height: 94%;\n  width: 100%;\n  z-index: 0;\n}\n\n.info {\n  display: flex;\n  align-items: center;\n  z-index: 1;\n  position: relative;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.info > img {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n}\n\n.infoBalance {\n  font-size: 22px;\n  font-weight: 560;\n  letter-spacing: 0.43px;\n}\n\n.infoBalanceUSD {\n  font-size: 16px;\n  line-height: 125%;\n  letter-spacing: -0.5px;\n}\n\n.infoActions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 8px;\n  border-radius: 28px;\n  background: rgba(64, 69, 74, 0.40);\n  position: relative;\n  z-index: 1;\n  backdrop-filter: blur(28.950000762939453px);\n  -webkit-backdrop-filter: blur(28.9px); \n}\n\n.infoActionButton {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n  position: relative;\n  background: none;\n  font-size: 14px;\n  font-weight: 400;\n  font-family: 'Inter';\n  transition: background 0.3s ease 0s;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.infoActionButton:active {\n    background: rgba(var(--placeholder-tertiary), 0.2);\n}\n\n/* .infoActionButton:hover {\n  background: rgba(var(--placeholder-tertiary), 0.2);\n} */\n\n/* .infoActionButton:hover {\n  opacity: 0.80;\n} */\n\n@media (max-width: 370px) {\n  .infoActionButton {\n    padding: 5px 10px;\n    font-size: 13px;\n  }\n  .infoActionss > .infoActionButton {\n    padding: 5px 8px !important;\n  }\n}\n\n@media (max-width: 340px) {\n  .infoActionButton > svg {\n    width: 35px;\n    height: 35px;\n  }\n  .infoDivider {\n    display: none;\n  }\n  .infoActionss > .infoActionButton {\n    font-size: 10.5px;\n  }\n}\n\n.infoActionss > .infoDivider {\n  display: none;\n}\n\n.infoActionss > .infoActionButton {\n  padding: 5px 8px !important;\n}\n\n.infoDivider {\n  width: 1px;\n  height: 53px;\n  background: rgb(var(--placeholder-primary));\n  opacity: 0.1;\n}\n\n@media (max-width: 350px) {\n  .infoActions {\n    padding: 10px 3px;\n  }\n}\n\n/*--------------------stats--------------------*/\n  \n.modalStats {\n  background: rgb(var(--secondary-bg), 0.40);\n  border-radius: 32px;\n  padding: 20px 16px;\n  position: relative;\n  margin-bottom: 24px;\n}\n/* \n.statsLeft {\n  position: absolute;\n  top: 21px;\n  left: 16px;\n} */\n\n.priceUSD {\n  font-size: 22px;\n  font-weight: 760;\n  line-height: 120%;\n}\n\n.priceChange {\n  font-size: 14px;\n}\n\n.stats canvas {\n  width: 100% !important;\n}\n\n/*--------------------/stats--------------------*/\n\n/*--------------------transactions--------------------*/\n  \n.transactions {\n  background: rgb(var(--secondary-bg), 0.40);\n  border-radius: 32px;\n  padding: 16px;\n}\n\n/* .checkModal {\n  padding: 20px;\n} */\n\n.transactions {\n  padding: 20px 16px;\n}\n\n\n/*--------------------/transactions--------------------*/\n\n.background {\n  position: absolute;\n  z-index: -1;\n  width: 100%;\n  height: 40%;\n  bottom: 0;\n  border-radius: 600px;\n  background: rgba(0, 122, 255, 0.25);\n  filter: blur(110px) !important;\n  -webkit-backdrop-filter: blur(110px) !important; \n}\n\n/*--------------------/new design--------------------*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalTopButton": `qe3GD6nxZPQDbku2hPdG`,
	"modalTitle": `__jzG5Ss6RFEscNKufhG`,
	"modal2": `QUEcvupL27lfmKkIU35S`,
	"actionsButtons": `O8a8Xv901xsID4LEQH9x`,
	"actionsButton2": `_opMVLKHFHFvQ6s1PsAn`,
	"actionButton": `xdmP5W8XbFu0KzdJ6j9A`,
	"transactions": `aygDtd3s9WSGdFecg25C`,
	"transactionsTitle": `knIfFT4tVdNoj9R6ISgg`,
	"historyEmpty": `eTLhb2MHsqO6ZgaXMPUH`,
	"transItems": `ZMvrvzx9O7k49ZVjDJQj`,
	"transItem": `LtqPw8QcJeM0dKHqsc3Z`,
	"transItemLeft": `AcIbmDxJsYwN6ql1xTPQ`,
	"transItemLogo": `Au4BVMkfY4k_CcoCff0w`,
	"transItemLeftStatus": `w8Q4LjSg62_JTBfrZkBh`,
	"transItemLeftFrom": `t7I0EMaa4ScqOVQ60CQ4`,
	"transItemRight": `XR0WiW9vaIhyyyAMG1Kh`,
	"transWeb": `UOKTke90FGH4ukaFWY48`,
	"modalInner": `_8FOUGVRr697wHlCArPL`,
	"modalInfo": `mCH41iDVexr0pvyqIC80`,
	"modalBg": `Le1R8xuf08MFvH6L8KVG`,
	"info": `iTeCBpe_1ZZetmKmm24y`,
	"infoBalance": `gs0_v82A9dmz0yKkifgp`,
	"infoBalanceUSD": `myeif2Equ35sbM61bDGD`,
	"infoActions": `Y8taCPxrXrtxQ75I9VfA`,
	"infoActionButton": `T7w1rHIVIrQaCigO8zPa`,
	"infoActionss": `eztltzYMyforvSqLSj6S`,
	"infoDivider": `HG2oSYuMIjH1mjh6oc2D`,
	"modalStats": `xGfqP_qaaddGGrVlO0s_`,
	"priceUSD": `qKOAOQJnsl0vaDMTD8JN`,
	"priceChange": `ZD5K2zXvbzhWccNDMOac`,
	"stats": `dUyhRu8pI2zqPWFXqH8c`,
	"background": `IGB1lpbQue8GLR5SMoZ_`
};
export default ___CSS_LOADER_EXPORT___;
